<template>
  <transition @enter="onEnterMenu" @leave="onLeaveMenu">
    <section :class="$style.menu">
        <div :class="$style.parallaxContainer" ref="parallaxer">
          <!-- <Parallax :images="global.menuParallax" :class="$style.parallax" data-parallax /> -->
          <BigMenuBracelet ref="bracelet" />
          <Sound :class="$style.parallaxSound" :sound="sound" />
        </div>
        <div :class="$style.menuWrapper" data-wrapper>
          <nav :class="$style.menuNav">
            <ul>
              <li
                data-link
                v-for="(voice, i) in global.header"
                :key="voice.id"
                :data-key="voice.id"
                :class="[
                  $style.voice,
                  currentIndex !== i && currentIndex !== -1 ? $style['voice--disactive'] : false,
                  i === 4 ? $style.marginVoice : false,
                ]"
                @mouseenter="currentIndex = i"
                @mouseleave="currentIndex = -1"
              >
                <router-link
                  @click.native="clickVoice(voice.id)"
                  @mouseenter.native="$hover"
                  :to="{ name: voice.id }"
                  v-html="$options.filters.menuVoice(voice.title)"></router-link>
                  <p>{{ voice.subtitle }}</p>
              </li>
            </ul>
          </nav>
          <div :class="$style.subMenu" data-socials>
            <div :class="$style.subscribe">
              <a href="#!" @click.prevent="setSubscribe" v-if="!sent" @mouseenter="$hover">Subscribe</a>
              <span v-if="sent">{{ textSubscribe }}</span>
            </div>
            <ul :class="$style.socials">
              <li><a href="https://www.facebook.com/getwearable/" target="_blank" rel="noopener" @mouseenter.native="$hover"><Icon :class="$style['submenu__icon']" :id="'facebook'" /></a></li>
              <li><a href="https://www.instagram.com/getwearable/" target="_blank" rel="noopener" @mouseenter.native="$hover"><Icon :class="$style['submenu__icon']" :id="'instagram'" /></a></li>
              <li><a href="https://linkedin.com/company/deed-s.r.l." target="_blank" rel="noopener" @mouseenter.native="$hover"><Icon :class="$style['submenu__icon']" :id="'linkedin'" /></a></li>
            </ul>
            
            <transition @enter="enterNewsletter" @leave="leaveNewsletter">
              <NewsletterForm :setSubscribe="setSubscribe" v-show="subscribe" />
            </transition>
          </div>

        </div>
        <div :class="$style.opener" ref="opener"></div>
    </section>
  </transition>
</template>

<script>
import gsap from 'gsap'
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/scripts/event-bus'

import Icon from '@/components/Icon'
import BigMenuBracelet from '@/components/BigMenuBracelet'
import Sound from '@/components/Sound'
import NewsletterForm from '@/components/NewsletterForm'

export default {
  components: {
    Icon,
    BigMenuBracelet,
    Sound,
    NewsletterForm,
  },

  props: {
    sound: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(['global', 'IsMenuInTransition']),

    ...mapGetters(['currentHand'])
  },

  data() {
    return {
      isAnimating: false,
      currentIndex: -1,
      subscribe: false,
      sent: false,
      textSubscribe: 'Subscribe',
    };
  },

  filters: {
    menuVoice(value) {
      if (!value) return ''

      const regexp = /^(get)/
      const split = value.split(regexp)

      if (split.length > 1) return `${split[0]}${split[1]}<span>${split[2]}</span>`
      return value
    }
  },

  methods: {
    clickVoice(hand) {
      if (this.IsMenuInTransition) return

      this.$store.dispatch('TRIGGER_MENU')
      EventBus.$emit('slideHand', {
        direction: 'right',
        currentHand: this.currentHand(hand),
        fromMenu: true
      })
    },

    onEnterMenu(el, done) {
      if (this.IsMenuInTransition) return
      this.$store.commit('SET_IS_MENU_IN_TRANSITION', true)

      const tl = new gsap.TimelineMax({ onComplete: done })
      const openerEndPosition = this.isMobile() ? 0 : 50
      this.$refs.bracelet.resize()

      tl
        .set('[data-socials]', { yPercent: 100 })
        .set('[data-parallax], [data-wrapper]', { autoAlpha: 0 })
        .add('opener')
        .fromTo(this.$refs.opener, 1, {
          xPercent: -100
        }, {
          xPercent: openerEndPosition,
          ease: gsap.Expo.easeOut
        }, 'opener')
        .fromTo(this.$refs.parallaxer, 0.8, {
          xPercent: -100
        }, {
          xPercent: 0,
          ease: gsap.Expo.easeOut
        }, 'opener')
        .to('[data-parallax]', 0.5, {
          autoAlpha: 1,
          ease: gsap.Power2.easeInOut
        }, '-=0.6')
        .set('[data-wrapper]', { autoAlpha: 1 })
        .add('start-=2.5')
        .staggerFromTo('[data-link]', 0.5, {
          autoAlpha: 0,
          y: 20
        }, {
          autoAlpha: 1,
          y: 0,
          ease: gsap.Power2.easeInOut
        }, 0.05, 'start')
        .to('[data-socials]', 1.5, {
          yPercent: 0,
          ease: gsap.Expo.easeInOut
        }, 'start')
        .add(() => {
          this.$store.commit('SET_IS_MENU_IN_TRANSITION', false)
        })
    },

    onLeaveMenu(el, done) {
      if (this.IsMenuInTransition) return
      this.$store.commit('SET_IS_MENU_IN_TRANSITION', true)

      const tl = new gsap.TimelineMax({ onComplete: done })
      const openerStartPosition = this.isMobile() ? 0 : 50

      tl
        .add('start')
        .staggerTo('[data-link]', 0.5, {
          autoAlpha: 0,
          y: 20
        }, 0.03, 'start')
        .to('[data-socials]', 0.8, {
          yPercent: 100,
          ease: gsap.Expo.easeInOut
        }, 'start')
        .set('[data-wrapper]', { autoAlpha: 0 })
        .add('second')
        .fromTo(this.$refs.opener, 1, {
          xPercent: openerStartPosition,
          autoAlpha: 1
        }, {
          xPercent: -100,
          ease: gsap.Expo.easeOut
        }, 'second')
        .to(this.$refs.parallaxer, 0.7, {
          xPercent: -100,
          ease: gsap.Expo.easeOut
        }, 'second')
        .add(() => { this.$store.commit('SET_IS_MENU_IN_TRANSITION', false) })
    },

    setSubscribe(sent) {
      this.subscribe = !this.subscribe;

      const parallaxer = this.$refs.parallaxer;
      const nav = this.$el.querySelector('nav');

      if (this.subscribe) {
        parallaxer.addEventListener('click', this.setSubscribe);
        nav.addEventListener('click', this.setSubscribe);
      } else {
        parallaxer.removeEventListener('click', this.setSubscribe);
        nav.removeEventListener('click', this.setSubscribe);
      }

      if (sent === 'sent') {
        this.sent = true;
        this.textSubscribe = this.global.newsletter.thxMsg;
      }
    },

    enterNewsletter(el, done) {
      const tl = new gsap.TimelineMax({ onComplete: done });

      tl.add('start')
      .set(el.children, {
        autoAlpha: 0,
        yPercent: 100,
      })
      .to(el, 0.8, {
        scaleY: 1,
        autoAlpha: 1,
        transformOrigin: '50% 100%',
        ease: gsap.Expo.easeInOut
      }, 'start')
      .to(el.children, 0.8, {
        yPercent: 0,
        autoAlpha: 1,
        ease: gsap.Expo.easeInOut
      }, 'start+=0.5')
    },

    leaveNewsletter(el, done) {
      const tl = new gsap.TimelineMax({ onComplete: done });

      tl.add('start')
      .to(el.children, 1.2, {
        yPercent: 100,
        autoAlpha: 0,
        ease: gsap.Expo.easeOut
      }, 'start')
      .to(el, 1.2, {
        scaleY: 0,
        autoAlpha: 0,
        ease: gsap.Expo.easeOut
      }, 'start')
    },
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: z-index(header) - 1;
  display: flex;
}

.parallaxContainer {
  position: relative;
  display: none;

  height: 100%;
  z-index: 1;
  background-color: #0f0f0f;

  @include mq(md) {
    width: 50%;
    display: block;
  }

  .parallax {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 50%;
    margin: auto;
  }

  .parallaxSound {
    position: fixed;
    left: 60px;
    bottom: 20px;
  }
}

.menuNav {
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding-top: 72px;
  padding-left: $standard-margin-mobile;

  @include mq(sm) {
    padding-top: 0px;
    padding-left: 40px;
  }

  @include mq(md) {
    justify-content: center;
    padding-bottom: 0;
    padding-left: 80px;
  }

  ul {
    @include mq(md) {
      padding-top: 50px;
    }
  }
}

.menuWrapper {
  position: relative;
  display: flex;
  width: 100%;
  flex-flow: column;
  background: $color-dark;
  z-index: 3;

  @include mq(md) {
    width: 50%;
  }
}

.voice {
  position: relative;
  display: block;
  padding: 16px 0;
  transition: opacity 0.3s ease-out;

  @include mq(sm) {
    padding: 12px 0;
  }

  a,
  a:visited {
    position: relative;
    text-transform: uppercase;
    font-size: font-size(14px);
    font-weight: 800;
    letter-spacing: 3px;
    color: $color-link;

    &::after {
    content: "";
      position: absolute;
      top: 0;
      right: 100%;
      bottom: 0;
      margin: auto 5px;
      width: $line-width-mobile;
      height: 1px;
      background: white;
      transition: transform 0.3s ease-out;
      transform-origin: 0%;
      transform: scale(0, 1);

      @include mq(sm) {
        width: $line-width;
      }
    }
  }

  :global .router-link-exact-active::after {
    transform: scale(1, 1);
  }

  :global(.no-touchevents) &.voice--disactive {
    opacity: 0.55 !important;
  }

  :global(.no-touchevents) &:hover {
    a::after {
      transform: scale(1, 1);
    }
  }

  :global(.no-touchevents) &:hover {
    a::after {
      transform: scale(1, 1);
    }
  }

  span {
    font-style: italic;
  }

  p {
    color: $color-blue;
    font-size: font-size(14px);
    display: none;
    margin-top: 3px;

    @include mq(sm) {
      display: block;
    }
  }
}

.subMenu {
  position: relative;
  background: $color-dark-two;

  display: flex;
  align-items: center;
  justify-content: stretch;

  // overflow: hidden;

  .subscribe {
    flex: 0 0 50%;
    padding: 30px 0 30px 30px;

    @include mq(sm) {
      padding: 60px 0 60px 80px;
    }

    background-color: $color-dark-two;

     & a, & span {
      color: $color-blue;
      transition: opacity 0.3s ease-out;

      :global(.no-touchevents) &:hover {
        color: $color-blue;
        opacity: 0.7;
      }
    }
  }

  .submenu__icon {
    fill: $color-blue;
  }

  .socials {
    flex: 0 0 50%;
    padding: 30px 30px 30px 0;

    @include mq(sm) {
      padding: 60px 80px 60px 0;
    }

    display: flex;
    justify-content: flex-end;

    li {
      padding-left: $standard-margin-mobile / 2;

      a {
        padding: 5px;
        transition: opacity 0.3s ease-out;

        :global(.no-touchevents) &:hover {
          opacity: 0.7;
        }
      }

      @include mq(sm) {
        padding-left: $standard-margin / 2.5;
      }

      &:first-child {
        padding: 0;
      }
    }
  }
}

.marginVoice {
  margin-top: 30px;

  @include mq(sm) {
    margin-top: 80px;
  }
}


.opener {
  @include boost-performance();
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 2;
  background: $color-dark;
}
</style>



// WEBPACK FOOTER //
// src/components/BigMenu.vue